<template>
  <v-row dense>
    <v-col cols="3">
      <v-text-field
        v-if="readonly"
        name="date"
        :value="form.date | dateFormat"
        :label="`${$t('ITEM.DATE')} *`"
        :rules="rules.date"
        :error-messages="errors.date"
        prepend-inner-icon="mdi-calendar"
        readonly
      ></v-text-field>

      <v-menu
        v-else
        ref="menuDate"
        min-width="290px"
        transition="scale-transition"
        :close-on-content-click="false"
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            name="date_from"
            autocomplete="nope"
            prepend-inner-icon="mdi-calendar"
            :value="form.date | dateFormat"
            :label="`${$t('ITEM.DATE')} *`"
            :rules="rules.date"
            readonly
            role="button"
            :error-messages="errors.date"
            clearable
            v-bind="attrs"
            v-on="on"
            @click:clear="form.date = null"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="form.date"
          first-day-of-week="1"
          @change="setDate"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <v-col cols="5">
      <v-text-field
        v-model="form.title"
        name="title"
        :counter="65"
        :readonly="readonly"
        :rules="rules.title"
        :label="`${$t('SERVICES.ITEM')} *`"
        :error-messages="errors.title"
        @input="updateValue('title', $event)"
      ></v-text-field>
    </v-col>

    <v-col cols="2">
      <v-text-field
        v-model.number="form.duration"
        name="duration"
        type="number"
        min="0"
        step="0.01"
        :rules="rules.duration"
        :readonly="readonly"
        :label="`${$t('EREPORTER.INVOICES.DURATION_UNIT')} *`"
        :error-messages="errors.duration"
        @input="updateValue('duration', $event)"
      ></v-text-field>
    </v-col>
    <v-col cols="2">
      <money-input
        v-model="form.unit_price"
        :rules="rules.unit_price"
        :readonly="readonly"
        :label="`${$t('EREPORTER.INVOICES.PRICE_CURRENCY_UNIT')} *`"
        :error-messages="errors.unit_price"
        @input="updateValue('unit_price', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import {
  notEmpty,
  maxLength,
  notEmptyWithNull
} from '@/modules/_global/variables/rules';
import { dateFormat } from '@/modules/_global/filters';
import moment from 'moment';
import { isEqual } from 'lodash';
import MoneyInput from '@/modules/_global/_components/money/MoneyInput.vue';

export default {
  name: 'InvoiceLineForm',
  components: { MoneyInput },

  filters: {
    dateFormat
  },

  mixins: [formEditable],

  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      form: {
        date: null,
        title: '',
        unit_price: 0,
        duration: 1
      },
      rules: {
        title: [notEmpty, maxLength(65)],
        duration: [notEmpty],
        date: [notEmpty],
        unit_price: [notEmptyWithNull]
      }
    };
  },

  computed: {
    price() {
      const price = this.form.duration * this.form.unit_price;

      return Math.round((price + Number.EPSILON) * 100) / 100;
    }
  },

  watch: {
    price(value) {
      this.form.price = value;
    }
  },

  created() {
    if (!isEqual(this.value, this.form)) {
      this.form.date = moment(Date.now()).format('YYYY-MM-DD');
    }
  },

  methods: {
    setDate(date) {
      this.$refs.menuDate.save(date);
      this.updateValue('date', date);
    }
  }
};
</script>

<style scoped></style>
